import React from "react";

const Card = ({
  children,
    bgColor = "#FFFFEB",
  textColor = "#1A1A1A",
  className = "",
  ...props
}) => {
  const baseClasses =
    "p-10 rounded-3xl border-2 border-black shadow-[6px_6px_0px_0px_black] transition-all duration-300 ease-in-out transform hover:scale-105";

  const combinedClasses = `${baseClasses} ${className}`;

  return (
    <div
      className={combinedClasses}
      style={{ backgroundColor: bgColor, color: textColor }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
